import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class PlatformchkService {
  constructor(private platform: Platform) {}

  // 네이티브 앱 환경인지 확인 (Capacitor 기반)
  public get isApp(): boolean {
    return Capacitor.isNativePlatform();
  }

  // PC 웹
  public get isPcWeb(): boolean {
    return (
      this.platform.is('desktop') &&
      !this.platform.is('mobileweb') &&
      !this.isApp
    );
  }

  // 모바일 웹
  public get isMobileWeb(): boolean {
    return this.platform.is('mobileweb') && !this.isApp;
  }

  // iOS 앱
  public get isIOS(): boolean {
    return this.platform.is('ios') && this.isApp;
  }

  // Android 앱
  public get isAndroid(): boolean {
    return this.platform.is('android') && this.isApp;
  }
}